import { Center, Flex, SimpleGrid, Text } from "@mantine/core";
import { useFormContext } from "react-hook-form";
import { PaymentSummary } from "./PaymentSummary";
import { IPostBuyPlan } from "../../interfaces/Purchase";
import {
  TextInputControlled,
  IMaskInputControlled,
  SelectControlled,
  SectionsForm,
  FinishStep,
} from "../../components";
import { useAuth } from "../../context/auth";
import { useTranslation } from "react-i18next";
interface IProps {
  isLoading: boolean;
  isFree: boolean;
}
const PurchaseStep3 = ({ isLoading = false, isFree }: IProps) => {
  const { t } = useTranslation();
  const { interest } = useAuth();
  const { watch } = useFormContext<IPostBuyPlan>();
  const selectedInterest = interest.filter((item) => item.selected);

  const hasDirtySecond = watch("plans")?.length === selectedInterest.length;

  return hasDirtySecond ? (
    isFree ? (
      <SectionsForm
        title={t("marketplace.comprar_serviços.purchase_step_2.title_section")}
        number={"03"}
      >
        <PaymentSummary isLoading={isLoading} isFree={isFree} />
      </SectionsForm>
    ) : (
      <Flex gap="32px" w="100%">
        <SectionsForm
          title={t(
            "marketplace.comprar_serviços.purchase_step_2.title_section"
          )}
          number={"03"}
        >
          <Flex direction={"column"} gap={24}>
            <Text
              fz={{ base: 24 }}
              fw={{ base: 600 }}
              lh={{ base: "37.2px" }}
              c={"basic.5"}
            >
              {t("marketplace.comprar_serviços.purchase_step_3.credit_card")}
            </Text>

            <SimpleGrid cols={1} spacing="32px" verticalSpacing="24px">
              <SelectControlled
                data={["Visa", "Mastercard", "American Express"]}
                name="payment_info.issuer"
                label={t("global.input.issuer_card.label")}
                placeholder={t("global.input.issuer_card.label")}
                withAsterisk
              />
              <IMaskInputControlled
                name="payment_info.number"
                label={t("global.input.number_card.label")}
                placeholder={t("global.input.number_card.label")}
                mask="0000 0000 0000 0000"
                withAsterisk
              />
            </SimpleGrid>
            <TextInputControlled
              name="payment_info.name"
              label={t("global.input.name_card.label")}
              placeholder={t("global.input.name_card.label")}
              withAsterisk
            />
            <SimpleGrid cols={2} spacing="32px" verticalSpacing="24px">
              <IMaskInputControlled
                name="payment_info.maturity"
                label={t("global.input.expiration_card.label")}
                placeholder={t("global.input.expiration_card.label")}
                mask="00/00"
                withAsterisk
              />
              <IMaskInputControlled
                name="payment_info.cvv"
                label={t("global.input.cvv_card.label")}
                placeholder={t("global.input.cvv_card.label")}
                mask="000"
                withAsterisk
              />
            </SimpleGrid>
          </Flex>
        </SectionsForm>
        <PaymentSummary isLoading={isLoading} isFree={isFree} />
      </Flex>
    )
  ) : (
    <SectionsForm
      title={t("marketplace.comprar_serviços.purchase_step_2.title_section")}
      number={"03"}
    >
      <FinishStep />
    </SectionsForm>
  );
};
export default PurchaseStep3;
